import { useState } from "react";
import axios from "axios";
import { TbX, TbHome, TbInfoCircle } from "react-icons/tb";

export default function AvailabilityDrawer({ open, setOpen, room, refreshRooms, onSuccess }) {

  const [loading, setLoading] = useState(false);
  const [totalRooms, setTotalRooms] = useState(1);

  const handleSave = async () => {
    if (!totalRooms || totalRooms < 1) return;

    try {
      setLoading(true);

      await axios.post(
        `https://api.komorotel.com/api/availability/${room._id}/init`,
        {
          startDate: new Date().toISOString().split("T")[0],
          endDate: "2027-12-31",
          totalRooms
        },
        { withCredentials: true }
      );

      refreshRooms();
      setOpen(false);
      onSuccess?.();

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">

      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/30 backdrop-blur-sm"
        onClick={() => setOpen(false)}
      />

      {/* Drawer */}
      <div className="relative w-full max-w-md bg-white h-full shadow-2xl flex flex-col">

        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <div>
            <h2 className="text-base font-bold text-gray-900">
              Configurer la disponibilité
            </h2>
            <p className="text-xs text-gray-400 mt-0.5">
              {room?.title}
            </p>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
          >
            <TbX className="text-gray-500" />
          </button>
        </div>

        {/* CONTENT */}
        <div className="flex-1 overflow-y-auto px-6 py-6 flex flex-col gap-6">

          {/* Info banner */}
          <div className="flex items-start gap-3 px-4 py-3 bg-blue-50 border border-blue-100 rounded-xl">
            <TbInfoCircle className="text-blue-500 text-lg shrink-0 mt-0.5" />
            <p className="text-xs text-blue-700 leading-relaxed">
              La disponibilité sera configurée automatiquement jusqu'en décembre 2027. Vous pourrez fermer des dates spécifiques depuis le calendrier.
            </p>
          </div>

          {/* Sélecteur nombre de chambres */}
          <div>
            <label className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 block">
              Nombre d'unités disponibles
            </label>

            {/* Compteur premium */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl border border-gray-100">
              <button
                onClick={() => setTotalRooms(Math.max(1, totalRooms - 1))}
                className="w-10 h-10 rounded-xl border border-gray-200 bg-white flex items-center justify-center text-gray-600 hover:border-[var(--k-green)] hover:text-[var(--k-green)] transition font-medium text-lg"
              >
                −
              </button>

              <div className="text-center">
                <p className="text-4xl font-bold text-gray-900">{totalRooms}</p>
                <p className="text-xs text-gray-400 mt-1">
                  {totalRooms === 1 ? "unité" : "unités"}
                </p>
              </div>

              <button
                onClick={() => setTotalRooms(totalRooms + 1)}
                className="w-10 h-10 rounded-xl border border-gray-200 bg-white flex items-center justify-center text-gray-600 hover:border-[var(--k-green)] hover:text-[var(--k-green)] transition font-medium text-lg"
              >
                +
              </button>
            </div>

            <p className="text-xs text-gray-400 mt-2 text-center">
              Combien de fois cette chambre peut être réservée simultanément
            </p>
          </div>

          {/* Résumé visuel */}
          <div className="flex flex-col gap-2">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
              Résumé
            </p>
            <div className="flex flex-col gap-2">
              {[
                { label: "Chambre", value: room?.title },
                { label: "Période", value: `Aujourd'hui → Déc. 2027` },
                { label: "Unités", value: `${totalRooms} disponible${totalRooms > 1 ? "s" : ""}` },
              ].map((item, i) => (
                <div key={i} className="flex justify-between text-sm py-2 border-b border-gray-50">
                  <span className="text-gray-400">{item.label}</span>
                  <span className="font-semibold text-gray-800">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* FOOTER */}
        <div className="px-6 py-4 border-t border-gray-100">
          <button
            onClick={handleSave}
            disabled={loading || !totalRooms}
            className={`
              w-full py-3 rounded-xl text-sm font-semibold transition
              ${loading || !totalRooms
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-[var(--k-green)] text-white hover:bg-[var(--k-green-hover)] active:scale-[0.98]"
              }
            `}
          >
            {loading ? "Configuration..." : "Confirmer"}
          </button>

          <p className="text-xs text-center text-gray-400 mt-2">
            Vous pourrez modifier la disponibilité depuis le calendrier
          </p>
        </div>

      </div>

    </div>
  );
}